// eslint-disable-next-line max-len
import { VehicleTemplateDetail } from '@quorum/models/xs-resource';

import { createSelector, createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface TemplateDetailState extends EntityState<VehicleTemplateDetail> {
  error: string;
}

export const templateDetailAdapter: EntityAdapter<VehicleTemplateDetail> = createEntityAdapter<VehicleTemplateDetail>({
  selectId: (templateDetail: VehicleTemplateDetail) => templateDetail.headerId + ':' + templateDetail.sequence
});

export const initialState: TemplateDetailState = templateDetailAdapter.getInitialState({ error: null });
export const templateDetailFeatureSelector = createFeatureSelector<any>('vehicleMaintenance');
export const templateDetailSelector = createSelector(
  templateDetailFeatureSelector,
  (state: any) => state.templateDetail
);

export const templateDetailErrorSelector = createSelector(
  templateDetailFeatureSelector,
  (state: any) => state.templateDetail.error
);

export const { selectIds, selectEntities, selectAll, selectTotal } = templateDetailAdapter.getSelectors(
  templateDetailSelector
);
